import React, { useState, useEffect, useRef } from 'react';
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

import './desktop-custom-select-style.scss';

import Typography from '@src/componentsNew/Typography/Typography';

interface IProps {
  label?: string;
  options: any[];
  value: any;
  onChange: (value) => void;
}

const DesktopCustomSelect = ({ label, options, value, onChange }: IProps) => {
  const [isOptionOpen, setIsOptionOpen] = useState(false);
  const selectRef = useRef(null);

  useEffect(() => {
    window.addEventListener('click', handleClickOutside);

    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, []);

  const handleToggleOptions = () => {
    setIsOptionOpen(!isOptionOpen);
  };

  const handleOptionClick = (newOption) => {
    onChange(newOption);
    setIsOptionOpen(false);
  };

  const handleClickOutside = (event) => {
    if (selectRef.current && !selectRef.current.contains(event.target)) {
      setIsOptionOpen(false);
    }
  };

  return (
    <div className="custom-select-container" ref={selectRef}>
      <Typography
        cName="custom-select-value"
        variant="body3"
        component="div"
        style={{ color: '#212121' }}
        onClick={handleToggleOptions}>
        {label && `${label} :`} {value}
      </Typography>
      {
        isOptionOpen &&
        <ul className="custom-select-options">
          {
            options.map((option) => (
              <Typography
                key={option.label}
                variant="body3"
                component="li"
                style={{ color: '#212121' }}
                onClick={() => handleOptionClick(option)}>
                {option.label}
              </Typography>
            ))
          }
        </ul>
      }
      {
        isOptionOpen ?
          <ArrowDropUpIcon className='select-icon' /> :
          <ArrowDropDownIcon className='select-icon' />
      }
    </div>
  );
};

export default DesktopCustomSelect;
